import { getUserTaxonomy } from '../getUserTaxonomy';

type IdentifyTrait = {
    user_uuid?: string | null;
};

export const identifyUser = async (window?: Partial<Window>) => {
    if (typeof window === 'undefined' || !window.analytics) {
        return;
    }

    const { user_uuid } = await getUserTaxonomy();
    const identifyTrait: IdentifyTrait = {
        user_uuid
    };

    if (user_uuid) {
        window.analytics.identify(user_uuid, identifyTrait);
    }
};
